const FORM_KEYS = {
  subject: 'subject',
  gradeLevel: 'gradeLevel',
  topic: 'topic',
  assessmentType: 'assessmentType',
  additionalInformation: 'additionalInformation',
  language: 'language',

  //default
  time: 'time',
  difficulty: 'difficulty',
  number: 'number',

  //American
  curriculumFramework: 'curriculumFramework',
  specificStandards: 'specificStandards',
  objective: 'objective',
  objective2: 'objective2',
  objective3: 'objective3',
  strategies: 'strategies',
};

export default FORM_KEYS;
